export const TRY_AUTH = "TRY_AUTH";
export const AUTH_SET_TOKEN = "AUTH_SET_TOKEN";
export const SET_HAS_ROOMS = "SET_HAS_ROOMS";


